import React, { createContext, useContext } from 'react';

export interface SharedStateContextProps {
  contentRef?: React.RefObject<HTMLDivElement>;
}

export const SharedStateContext = createContext<SharedStateContextProps>({});

export const SharedStateContextProvider = SharedStateContext.Provider;

export const useSharedStateContext = () => useContext(SharedStateContext);
